<div class="position-relative"
  [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
  <div>
    <div [attr.data-aos]="allElementAnimation ? allElementAnimation : null"
      class="app-header-background features-slider"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
      [ngClass]="activatePadding?'header-padding-top':''">
      <div class="section-block pt-0 pb-40 color-white global-max-width">
        <div [attr.data-aos]="itemsAnimation ? itemsAnimation : null" fxLayout="row" fxLayout.sm="column"
          fxLayout.xs="column" fxLayoutAlign="start start" *ngIf="features">
          <div fxFlex [ngClass]="classLogo" class="progress-bar"
            *ngFor="let feature of features;let progressBarIndex = index">
            <h3 [ngStyle]="{ 'color': feature.titleColor?feature.titleColor:'#000','font-weight': feature.fontWeight }">
              <span class="border"></span>{{feature.title}}
            </h3>
            <ul>
              <li [ngClass]="classFeature" *ngFor="let item of feature.skills;let skillsBarIndex = index">
                <span [ngStyle]="{ 'color': feature.textColor?feature.textColor:'#000' }"
                  class="progress-bar-skill">{{item.skill}}</span>
                <span [ngStyle]="{ 'color': feature.textColor?feature.textColor:'#000' }"
                  class="progress-bar-value">{{item.value}}%</span>
                <mat-progress-bar class="progress-bar-element" mode="determinate" value="{{item.value}}">
                </mat-progress-bar>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>